"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTeacher = void 0;
const getDefaultTeacher = () => ({
    id: "",
    text: "",
    originalHref: "",
    originalScheduleURI: "",
    labels: [],
    firstName: "",
    lastName: "",
    fullName: "",
});
exports.getDefaultTeacher = getDefaultTeacher;
//# sourceMappingURL=Teacher.js.map